// extracted by mini-css-extract-plugin
export default {"box":"SignUp_box__1C6oO","summary-content":"SignUp_summary-content__AAU+a","input-box":"SignUp_input-box__aGb6N","buttons":"SignUp_buttons__X60La"};